import { render, staticRenderFns } from "./_templates.vue?vue&type=template&id=06bfb194&scoped=true&"
import script from "./_templates.vue?vue&type=script&lang=js&"
export * from "./_templates.vue?vue&type=script&lang=js&"
import style0 from "./_templates.vue?vue&type=style&index=0&id=06bfb194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bfb194",
  null
  
)

export default component.exports